<div class="loading-indicator" *ngIf="loading$ | async"></div>
